import * as yup from 'yup';
import { booleanScheme, stringEmailScheme, stringScheme } from 'src/utils/validation-schemes';
import {
  getWorkflowFormAction,
  WorkflowAction,
  WorkflowFormValues,
} from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

// The default ("escalation") workflow edited in the onboarding and create-project flows.
export interface EscalationWorkflow {
  name?: string;
  description?: string;
  trigger_type?: string;
  trigger_value?: string;
  enabled?: boolean;
  type?: string;
  action?: WorkflowAction;
}

export type EscalationFormValues = WorkflowFormValues;

/** Form values for the escalation workflow, with defaults for a project that has none yet. */
export const getEscalationFormValues = (
  workflow: EscalationWorkflow | null | undefined,
): EscalationFormValues => ({
  name: workflow?.name || 'Escalation',
  description: workflow?.description || 'When AI lacks the knowledge to assist.',
  trigger_type: workflow?.trigger_type || 'when_asked',
  trigger_value: workflow?.trigger_value || '',
  action: workflow ? [getWorkflowFormAction(workflow.action)] : [],
});

export const escalationWorkflowSchema = yup.object({
  name: stringScheme({ required: true }),
  description: stringScheme({ required: true }),
  trigger_type: stringScheme({ required: false }),
  trigger_value: stringScheme({ required: false }),
  action: yup.array(
    yup.object({
      action_type: stringScheme({ required: false }),
      action_message: stringScheme({ required: false }),
      action_escalated_list: stringScheme({ required: false }),
      action_data_collection: stringScheme({ required: false }),
      action_fields_name: booleanScheme({ required: false }),
      action_fields_email: booleanScheme({ required: false }),
      action_fields_phone_number: booleanScheme({ required: false }),
      action_fields_custom: booleanScheme({ required: false }),
      action_message_type: stringScheme({ required: false }),
      message_before: stringScheme({ required: false }),
      receiver_email_addresses: stringEmailScheme({ required: false, format: true }),
      message_after: stringScheme({ required: false }),
      message_close: stringScheme({ required: false }),
      action_fields_custom_array: yup.array(
        yup.object({
          name: stringScheme({ required: false }),
          description: stringScheme({ required: false }),
        }),
      ),
    }),
  ),
});
